import React from 'react';
import styled from 'styled-components/macro';
import CrossPieceSchemaDimensions from '../CrossPieceSchemaDimensions';
import DrawerSchemaDimensions from './DrawerSchemaDimensions';
import { Shelf } from '../../../../lib/modelBuilder/entities/Shelf';
import { CustomPiece } from '../../../../lib/modelBuilder/pieces/CustomPiece';
import { Drawer } from '../../../../lib/modelBuilder/pieces/Drawer';
import { CompleteIntermediateShelf } from '../../../../lib/modelBuilder/entities/CompleteIntermediateShelf';
import InterShelfSchemaDimensions from './InterShelfSchemaDimensions';
import StyledDimensionValue from '../../styles/StyledDimensionValue';

interface Props {
  shelf: Shelf;
}

const ShelfSchemaDimensions = ({ shelf }: Props) => {
  const interShelvesFreeSpace = (): number => {
    let result = 0;
    shelf.intermediatesShelves
      .sort(
        (a: CompleteIntermediateShelf, b: CompleteIntermediateShelf) =>
          (b.position as number) - (a.position as number),
      )
      .map(
        (interShelf: CompleteIntermediateShelf, index: number) =>
          (result += interShelf.height),
      );
    return result;
  };
  const interShelvesRows = (): string => {
    let result = `${interShelvesFreeSpace()}fr`;
    shelf.intermediatesShelves
      .sort(
        (a: CompleteIntermediateShelf, b: CompleteIntermediateShelf) =>
          (b.position as number) - (a.position as number),
      )
      .map(
        (interShelf: CompleteIntermediateShelf, index: number) =>
          (result += ` ${interShelf.height}fr`),
      );
    return result;
  };
  const drawersRows = (): string => {
    let result = '';
    shelf.drawers
      .sort(
        (a: CustomPiece<Drawer>, b: CustomPiece<Drawer>) =>
          (b.position as number) - (a.position as number),
      )
      .map(
        (drawer: CustomPiece<Drawer>, index: number) =>
          (result += ` ${drawer.height}fr`),
      );
    return result;
  };
  return (
    <>
      <StyledShelfSchema heightShelf={shelf.height}>
        {shelf.drawers && shelf.drawers.length > 0 ? (
          <StyledDrawersSchema
            heightShelf={shelf.height}
            drawersRows={drawersRows()}
          >
            {shelf.drawers
              .sort(
                (a: CustomPiece<Drawer>, b: CustomPiece<Drawer>) =>
                  (b.position as number) - (a.position as number),
              )
              .map((drawer: CustomPiece<Drawer>, index: number) => (
                <DrawerSchemaDimensions
                  key={drawer.position}
                  drawer={drawer}
                  isLastDrawer={index === shelf.drawers.length - 1}
                />
              ))}
          </StyledDrawersSchema>
        ) : null}
        {shelf.intermediatesShelves && shelf.intermediatesShelves.length > 0 ? (
          <StyledInterShelvesSchema interShelvesRows={interShelvesRows()}>
            <StyledInterShelvesFreeSpaceSchema />
            {shelf.intermediatesShelves
              .sort(
                (a: CompleteIntermediateShelf, b: CompleteIntermediateShelf) =>
                  (b.position as number) - (a.position as number),
              )
              .map((interShelf: CompleteIntermediateShelf, index: number) => (
                <InterShelfSchemaDimensions
                  key={interShelf.position}
                  interShelf={interShelf}
                />
              ))}
          </StyledInterShelvesSchema>
        ) : null}

        {shelf.hasFrontDoor() ? <StyledDoors /> : null}

        <StyledDimensionContainer>
          <StyledDimensionValue bold>{shelf.height / 10}</StyledDimensionValue>
        </StyledDimensionContainer>
      </StyledShelfSchema>
      <CrossPieceSchemaDimensions />
    </>
  );
};

const StyledShelfSchema = styled.div<{
  heightShelf: number;
}>`
  grid-row-end: span 1;
  display: grid;
  position: relative;
`;

const StyledInterShelvesSchema = styled.div<{
  interShelvesRows: string;
}>`
  display: grid;
  grid-template-rows: ${p => p.interShelvesRows};
  grid-template-columns: 100%;
`;

const StyledInterShelvesFreeSpaceSchema = styled.div`
  grid-row-end: span 1;
`;

const StyledDrawersSchema = styled.div<{
  heightShelf: number;
  drawersRows: string;
}>`
  display: grid;
  grid-template-rows: ${p => p.drawersRows};
  grid-template-columns: 100%;
`;

const StyledDimensionContainer = styled.div`
  position: absolute;
  right: 0;
  top: calc(50% - 10px);
`;

const StyledDoors = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 50%;
  height: 100%;
  border-right: 1px solid black;
`;

export default ShelfSchemaDimensions;
